/* eslint-disable */
import {USERS_ERROR} from 'api/constant'
import axios from "axios";
import { message } from 'antd';
import { useDispatch } from 'react-redux'
import { logout } from './hub';

const API_BASE_URL = process.env.REACT_APP_API_URL
const ADMIN_API_BASE_URL = process.env.REACT_APP_ADMIN_API_URL

// set axios config

function getConfig(obj) {
    const BASE_URL = obj.scope === 'ADMIN'? ADMIN_API_BASE_URL:API_BASE_URL
    if(obj.auth) 
        return {
            url: obj.url,
            method: obj.method,
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('LoginInfo')).accessToken}`
            },
            baseURL: BASE_URL,
            responseEncoding: 'utf8',
            params: obj.method ==='GET' ?{...obj.params,"ip_address":localStorage.getItem('ip_address') ? localStorage.getItem('ip_address') :''} : null,
            data: {...obj.data,"ip_address":localStorage.getItem('ip_address') ? localStorage.getItem('ip_address') :''}
        }
    else
        return {
            url: obj.url,
            method: obj.method,
            headers: { 'Content-Type': 'application/json' },
            baseURL: BASE_URL,
            responseEncoding: 'utf8',
            params: obj.method ==='GET' ?{...obj.params,"ip_address":localStorage.getItem('ip_address') ? localStorage.getItem('ip_address') :''} : null,
            data: {...obj.data,"ip_address":localStorage.getItem('ip_address') ? localStorage.getItem('ip_address') :''}
        }
}

// axios global function setting
export const request = (obj) => async dispatch => {
    try{
        const res = await axios(getConfig(obj))
        if((res.data.code !== 200) && (res.data.code !== 201)){

            if(res.data.messages){
                if(localStorage.getItem('lang')==='en'){
                    if ([400, 401, 404, 500].indexOf(res.data.code) > -1) {
                        res.data.messages.map(m=>{
                            if(m.en){
                                message.error(m.en)
                            }else{
                                message.error(`${m.code}System exception error. Please contact our customer service.`)
                            }
                            location.replace(`${process.env.REACT_APP_REDIRECT_URL}`)
                        }
                        )                        
                    }else if(res.data.code === 999)
                    {
                        res.data.messages.map(m=>{
                            if([23013219, 500].indexOf(m.code) > -1){

                            }
                            else if(m.en){
                                message.error(m.en)
                            }else{
                                message.error(`${m.code}System exception error. Please contact our customer service.`)
                            }
                        }
                        )  
                    }
                }else{
                    if ([400, 401, 404, 500].indexOf(res.data.code) > -1) {
                        res.data.messages.map(m=>{
                            if(m.tw){
                                message.error(m.tw)
                            }else{
                                message.error(`${m.code}系統異常，請聯絡客服。`)
                            }
                            location.replace(`${process.env.REACT_APP_REDIRECT_URL}`)
                        }
                        )
                    }else if(res.data.code === 999)
                    {
                        res.data.messages.map(m=>{
                            if([23013219, 500].indexOf(m.code) > -1){

                            }
                            else if(m.tw){
                                message.error(m.tw)
                            }else{
                                message.error(`${m.code}系統異常，請聯絡客服。`)
                            }
                        }
                        )  
                    }
                }
            }else{
                message.error(`${localStorage.getItem('lang')==='en'?'Service exception error. Please try again later.':'服務異常，請稍後再試。'}`)
            }
        }
        dispatch( {
            type: obj.type,
            payload: res.data
        })
        return res.data
    }
    catch(e){
        dispatch( {
            type: USERS_ERROR,
            payload: console.log(e),
        })
        return e.response
    }

}